module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022-600x396.428dea1b.jpg";